import Home from "./pages/Home";
import "./App.css";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Home />;
      <Footer />
    </>
  );
}

export default App;
